import { IAppState } from '../../../AppModulesWrapper';
import { IGeoAddressItem } from '../../types/reducers/offer';

/**
 *
 * @description Массив address хранит гео в порядке ParentToChild (от наиболее общего гео к конкретному).
 * Например [регион, район, дом]. Данный селектор вернет последний элемент.
 */
export function selectGeoChildLocation(state: IAppState): IGeoAddressItem | null {
  const {
    offer: { geo },
  } = state.servicePickerWidget;

  const address = geo?.address || [];

  return address[address.length - 1] || null;
}
